import ConfigurationProfile from "../views/ConfigurationProfile";
import ConfigurationPremium from "../views/ConfigurationPremium";
import ConfigurationPreferences from "../views/ConfigurationPreferences";
import ConfigurationNotifications from "../views/ConfigurationNotifications";
import ConfigurationChangeEmail from "../views/ConfigurationChangeEmail";
import ConfigurationGroupManager from "../views/ConfigurationGroupManager";
import ConfigurationFederationFrancaiseVolLibre from "../views/ConfigurationFederationFrancaiseVolLibre";
import ConfigurationPureTrack from "../views/ConfigurationPureTrack";



export default class ConfigurationIndex {

    constructor() {
        this.configurationProfile = new ConfigurationProfile();
        this.configurationChangeEmail = new ConfigurationChangeEmail();
        this.configurationGroupManager = new ConfigurationGroupManager();
        this.ConfigurationFederationFrancaiseVolLibre = new ConfigurationFederationFrancaiseVolLibre();
        this.ConfigurationPureTrack = new ConfigurationPureTrack();
        this.configurationPremium = new ConfigurationPremium();
        this.configurationPreferences = new ConfigurationPreferences();
        this.configurationNotifications = new ConfigurationNotifications();
        window.application.setOnDataChangeListener(this);
        this.selectTab();
    }

    bindEvents() {
    }

    onDataChanged(data) {
        this.configurationProfile.onDataChanged(data);
        this.configurationPremium.onDataChanged(data);
        this.configurationChangeEmail.onDataChanged(data);
        this.configurationGroupManager.onDataChanged(data);
        this.ConfigurationFederationFrancaiseVolLibre.onDataChanged(data);
        this.ConfigurationPureTrack.onDataChanged(data);
    }

    onDestroy() {
        this.configurationProfile.onDestroy();
        this.configurationPremium.onDestroy();
        this.configurationChangeEmail.onDestroy();
        this.configurationGroupManager.onDestroy();
        this.ConfigurationFederationFrancaiseVolLibre.onDestroy();
        this.ConfigurationPureTrack.onDestroy();
    }

    selectTab() {
        let url = document.location.toString();
        let tabSelector;

        if (url.match('tab=')) {
            tabSelector = 'a[href="#' + url.split('tab=')[1] + '"]';
        } else {
            tabSelector = 'a[href="#profile"]';
        }

        // Show the tab and scroll to content on mobile after it's shown
        window.$(tabSelector).on('shown.bs.tab', () => {
            // Check if we're on mobile/tablet (viewport width < 768px, which is Bootstrap's md breakpoint)
            if (window.innerWidth < 768) {
                // Scroll to the tab content area
                const tabContent = document.getElementById('v-pills-tabContent');
                if (tabContent) {
                    tabContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        });

        window.$(tabSelector).tab('show');
    }
}